<template>
  <div>
    <CCard>
      <CCardHeader>
        <CIcon name="cil-grid" />Tambah Program Studi
      </CCardHeader>
      <CCardBody>
        <div class="form-group">
          <label>Program Study</label>
          <input type="text" class="form-control" v-model="data.name" />
        </div>
      </CCardBody>
      <CCardFooter>
        <btn-save-update :data="data" @save="saveStudy" @update="updateStudy" @back="goBack"/>
      </CCardFooter>
    </CCard>
  </div>
</template>
<script>
import GradeSelector from "../../components/GradeSelector"
import BtnSaveUpdate from "../../components/BtnSaveUpdate"
import { getErrorMessage } from "../../lib/helpers";
import { HTTPAUTH } from "../../lib/httplib";
export default {
  components: {
    GradeSelector,
    BtnSaveUpdate,
  },
  data() {
    return {
      data: {},
      faculty: {},
    };
  },
  created() {
    var slug = "";
    const route = this.$route;
    if (route.params && route.params.slug) {
      slug = route.params.slug;
    } else {
      location.href = "#/master/study-program";
      return;
    }
    this.getList(slug);
  },
  methods: {
    getList(slug) {
      HTTPAUTH.get(`/api/v1/study-program/${slug}`).then((res) => {
        this.data = res.data.data;
      });
    },
    saveStudy() {
      HTTPAUTH.post(`/api/v1/admin/study-program`, this.data)
        .then((res) => {
          this.$toasted.success("Data berhasil ditambahkan").goAway();
          this.data = res.data.data;
        this.getList(this.data.slug);
        })
        .catch((eres) => {
          this.$toasted.error(getErrorMessage(eres)).goAway();
        });
    },
    updateStudy() {
      HTTPAUTH.put(`/api/v1/admin/study-program/${this.data.id}`, this.data)
        .then((res) => {
          this.$toasted.success("Data berhasil ditambahkan").goAway();
        this.getList(this.data.slug);
        })
        .catch((eres) => {
          this.$toasted.error(getErrorMessage(eres)).goAway();
        });
    },
    goBack() {
      this.$router.push({path: "/master/study-program"})
    }
  },
};
</script>